import Vue from 'vue';
import AdPostPage from '../../../pages/AdPostPage/AdPostPage.vue';
import LoadModal from '../../../components/load-modal.vue';

const bus = new Vue();
global.bus = bus;

export default () => {
  new Vue({
    el: '.js-mount-vue',
    components: {
      AdPostPage,
      LoadModal,
    },
  });
};
